<ul cdkDropList class="list-group me-1" (cdkDropListDropped)="drop($event)">
    <li class="list-group-item d-block p-2">
        <div class="row w-100 d-flex align-items-center" (mouseover)="showPreview(null)">
            <div class="col-9 firstcol text-truncate">Blank</div>
        </div>
    </li>
    <li class="list-group-item d-block p-2 stationery-list-item" *ngFor="let item of stationery; let index = index" cdkDrag>
        <app-stationery-list-item [stationeryItem]="item" (mouseover)="showPreview(item)" (removeStationery)="removeStationery($event)"></app-stationery-list-item>
    </li>
</ul>